<template>
  <a
    :class="[
      bemBlock,
      'minicart',
      {
        'change-1': willChange,
        'change-2': !willChange,
      },
    ]"
    :href="url"
    :title="$msg('header.cart', 'header')"
    :aria-label="$msg('header.cart', 'header')"
  >
    <span class="number old">{{ previousQuantity }}</span>
    <span class="number new">{{ quantity }}</span>
  </a>
</template>

<script>
import { mapGetters } from 'vuex';
import bemClassesMixin from '../mixins/bemClassesMixin';
import getFrontConfig from '../../common/getFrontConfig';
import { getters } from '../store';

const FRONT_CONFIG = getFrontConfig();

export default {
  name: 'BaseMinicart',

  mixins: [bemClassesMixin],

  data() {
    return {
      previousQuantity: 0,
      quantity: 0,
      url: FRONT_CONFIG.urls.cartShow,
      willChange: false,
    };
  },

  computed: {
    ...mapGetters({
      totalQuantity: getters.cart.totalQuantity,
    }),
  },

  watch: {
    totalQuantity(newValue, oldValue) {
      this.previousQuantity = oldValue;
      this.willChange = true;
      setTimeout(() => {
        this.quantity = newValue;
        this.willChange = false;
      }, 100);
    },
  },

  mounted() {
    this.quantity = this.totalQuantity;
  },
};
</script>
